export const RELATIONSHIPS = ['father', 'mother', 'guardian', 'other'] as const
export type Relationship = (typeof RELATIONSHIPS)[number]

// Draft shape used in create mode (local only, sent in POST body).
export interface ParentDraft {
  fullName: string
  email: string
  phone: string
  relationship: Relationship
  isPrimary: boolean
}

// Shape returned by the API for each parent link (GET /:id parents array).
export interface ParentLink {
  id: string
  relationship: string | null
  isPrimary: boolean
  parentId: string
  parentEmail: string
  parentName: string | null
  parentPhone: string | null
}

export const blankParentDraft = (): ParentDraft => ({
  fullName: '',
  email: '',
  phone: '',
  relationship: 'guardian',
  isPrimary: true,
})

/**
 * Required-field guard shared by the New and Edit student forms. Exam board,
 * date of birth, school name, address and at least one class are mandatory.
 * Returns a human message naming the first gap, or null when complete.
 */
export function missingStudentFields(
  v: { fullName: string; examBoard: string; dateOfBirth: string; schoolName: string; address: string },
  classIds: Set<string>,
): string | null {
  if (!v.fullName.trim()) return 'Full name is required.'
  if (classIds.size === 0) return 'Select at least one class.'
  if (!v.examBoard) return 'Exam board is required.'
  if (!v.dateOfBirth) return 'Date of birth is required.'
  // Server requires strict YYYY-MM-DD; the date input normally yields this, but
  // guard so a stray value fails here with a clear message, not a generic 400.
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v.dateOfBirth)) return 'Date of birth must be in YYYY-MM-DD format.'
  if (!v.schoolName.trim()) return 'School name is required.'
  if (!v.address.trim()) return 'Address is required.'
  return null
}
